/**
 * Report dialog visibility only — brief markdown is assembled on the Insights host
 * (`reportMarkdown` / SSE `report-markdown`). Do not rebuild the brief on the client.
 */
import type { InsightsChatItem, InsightsTaskList } from "../types";

/** True when the chat has enough warm state to offer a report button. */
export function canShowInvestigationReport(input: {
  running: boolean;
  pending: boolean;
  items: InsightsChatItem[];
  taskList?: InsightsTaskList | null;
  runDurationMs?: number | null;
  /** Host-assembled brief markdown (preferred). */
  reportMarkdown?: string | null;
}): boolean {
  if (input.running || input.pending) return false;
  if (input.reportMarkdown?.trim()) return true;
  if (input.taskList?.tasks.length) return true;
  if (typeof input.runDurationMs === "number") return true;
  return input.items.some((item) => item.kind === "tool");
}
